import {
  Backdrop,
  Button, Card,
  CardActions,
  CardContent, CircularProgress, Container,
  Dialog,
  DialogActions, DialogContent,
  DialogTitle,
  Divider,
  InputBase,
  List,
  ListItemSecondaryAction,
  Paper,
  Snackbar
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CloseIcon from '@material-ui/icons/Close';
import CropFreeIcon from '@material-ui/icons/CropFree';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import KeyboardIcon from '@material-ui/icons/Keyboard';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import BarcodeDetay from 'react-barcode';
import Sound from 'react-sound';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import NotConnect from 'src/assets/sound/NotConnect.mp3';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BarkodPopup from '../../components/BarcodePopup';
import logger from 'src/utils/logger';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));



function Scrap() {
  const classes = useStyles();
  const [SuccessSound, setSuccessSound] = React.useState(false);
  const [NotConnectSound, setNotConnectSound] = React.useState(false);
  const [ErrorSound, setErrorSound] = React.useState(false);
  const [openBarkod, setOpenBarkod] = useState(false);
  const [BarcodeData, setBarcodeData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [txtBarcode, settxtBarcode] = useState('');
  const [txtBarcodeTekil, settxtBarcodeTekil] = useState('');
  const [BarcodeDetayPopup, setBarcodeDetayPopup] = React.useState(false);
  const [txtBarcodeLaser, settxtBarcodeLaser] = useState('');
  const SessionUser = getUser();

  const uyariKapat = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    if (barkod.length !== undefined && barkod !== "" && barkod.length > 0) {
      setSuccessSound(true);
      const index = BarcodeData.findIndex(item => item.Barcode === barkod);
      if (index !== -1) {
        const updatedData = [...BarcodeData];
        updatedData[index] = { Barcode: barkod };
        setBarcodeData(updatedData);
      } else {
        var newData = [...BarcodeData, { Barcode: barkod }];
        setBarcodeData(newData);
      }
      settxtBarcode("");
      settxtBarcodeLaser("");

    } else {
      setErrorSound(true);
      settxtBarcodeLaser("");
      settxtBarcode("");
    }
  }

  const ScrapSend = () => {
    setLoading(true);
    var BarcodeParam = BarcodeData.map(item => ({
      ...item,
      UserId: SessionUser.OrganizationUserId,
      StatusId: 2
    }));
    const body = BarcodeParam;
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post(`/SetScrapBarcode`, body, config)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          if (response.data[0]?.ErrorCode === 0) {
            setUyariTip('success');
            setBarcodeData([]);
          } else {
            setUyariTip('error');
          }
          setUyariAciklama(response.data[0]?.ErrorDescription);
          setUyari(true);
        }
      })
      .catch(error => {
        setLoading(false);
        setUyariTip('error');
        setUyariAciklama("Bir hata oluştu. Lütfen tekrar deneyiniz!...");
        setUyari(true);
              logger.error("Hata detayı:", error.message);
      });
  }

  const handleSendLaser = async (Param) => {
    if (!window.navigator.onLine) {
      setNotConnectSound(true);
      return;
    }
    try {
      await handleSendLaserOk(Param);
    } catch (error) {
    }
  };

  const handleSendLaserOk = (Param) => {
    axios.get(`/SetScrapBarcodeLaser/${Param}/${SessionUser.OrganizationUserId}`)
      .then(response => {
        if (response.data.toString() === "1") {
          setSuccessSound(true);
        } else {
          setErrorSound(true);
        }
      })
      .catch(error => {
      logger.error("Hata detayı:", error.message);
      });
    settxtBarcodeLaser("");
  }

  const fncBarcodePopup = (Barcode) => {
    settxtBarcodeTekil(Barcode);
    setBarcodeDetayPopup(true);
  }


  return (
    <Page className={classes.root} title="Malzeme Eskisi İşletmeye Gönderim">
      {NotConnectSound ?
        <Sound
          url={NotConnect} // Ses dosyasının yolunu buraya ekleyin
          playStatus={Sound.status.PLAYING} // Sesin çalmasını sağlar
          onFinishedPlaying={() => setNotConnectSound(false)} // Ses çalma tamamlandığında hata durumunu sıfırlar
        /> : ''}
      {SuccessSound ?
        <Sound
          url={BarcodeVoice} // Ses dosyasının yolunu buraya ekleyin
          playStatus={Sound.status.PLAYING} // Sesin çalmasını sağlar
          onFinishedPlaying={() => setSuccessSound(false)} // Ses çalma tamamlandığında hata durumunu sıfırlar
        /> : ''}
      {ErrorSound ?
        <Sound
          url={ErrorVoice} // Ses dosyasının yolunu buraya ekleyin
          playStatus={Sound.status.PLAYING} // Sesin çalmasını sağlar
          onFinishedPlaying={() => setErrorSound(false)} // Ses çalma tamamlandığında hata durumunu sıfırlar
        /> : ''}
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={uyariKapat}>
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardActions>
            <Paper component="form" className={classes.root}>
              <InputBase
                value={txtBarcodeLaser}
                onChange={event => settxtBarcodeLaser(event.target.value)}
                className={classes.input}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    // handleBarkodClose(txtBarcodeLaser);
                    handleSendLaser(txtBarcodeLaser);
                    event.preventDefault(); // Enter tuşunun varsayılan davranışını engelle
                  }
                }}
                placeholder="Lazer ile Barkod Okut..."
              />
              <Divider className={classes.divider} orientation="vertical" />
              <IconButton color="primary" className={classes.iconButton}
                onClick={() => handleBarkodClose(txtBarcodeLaser)}
                aria-label="directions">
                <FingerprintIcon />
              </IconButton>
            </Paper>
          </CardActions>
          <Divider />
          <CardActions>
            <Paper component="form" className={classes.root}>
              <InputBase
                value={txtBarcode}
                onChange={event => settxtBarcode(event.target.value)}
                className={classes.input}
                placeholder="Barkod Yazınız!..."
              />
              <Divider className={classes.divider} orientation="vertical" />
              <IconButton color="primary" className={classes.iconButton}
                onClick={() => handleBarkodClose(txtBarcode)}
                aria-label="directions">
                <KeyboardIcon />
              </IconButton>
            </Paper>
          </CardActions>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpenBarkod(true)}
              endIcon={<CropFreeIcon />}>
              Kamera İle Barkod Okut
            </Button>
          </CardActions>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              style={{ backgroundColor: 'green', color: 'white' }}
              onClick={ScrapSend}
              endIcon={<SendIcon />}>
              Depo Teslİm Aldı Gönder
            </Button>
          </CardActions>
          <Divider />
          <CardContent>
            <List style={{ height: '400px', width: '100%', maxHeight: 400, overflow: 'auto' }}>
              {BarcodeData.map(item => (
                <ListItem key={`${item.Barcode}`} button>
                  <ListItemText primary={`${item.Barcode}`} />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={() => fncBarcodePopup(item.Barcode)} aria-label="open">
                      <GpsFixedIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </CardContent>

        </Card>
      </Container>
      <Dialog
        open={BarcodeDetayPopup}
        onClose={() => setBarcodeDetayPopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Barkod Detayı
        </DialogTitle>
        <Divider />
        <DialogContent>
          <BarcodeDetay value={txtBarcodeTekil} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={() => setBarcodeDetayPopup(false)}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />

    </Page>
  );
}

export default Scrap;
